var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n   "+_vm._s(_vm.text)+"\n ")])}
var staticRenderFns = []

export { render, staticRenderFns }